(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    const lang = document.documentElement.lang || "es";

    if (lang.startsWith("it")) {
      // hide
      document.querySelector('.announcement-bar').style.display = "none";
    } else if (lang.startsWith("pt")) {
      // hide
      document.querySelector('.announcement-bar').style.display = "none";
    } else {
      // show
    }
  });
  } catch(e) { console.error(e); }
})();

})();
